export const LeadNotificationTestIds = {
  ACCEPT: 'lead-notification.accept-button',
  REJECT: 'lead-notification.reject-button',
};
